import React, { useEffect, useState } from "react";
import Vertical from "../assets/img/Vertical.jpg";
import Horizontal from "../assets/img/Horizontal.jpg";
import Square from "../assets/img/Square.jpg";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite"; 
import productOrientationStore from "../stores/ProductOrientationStore"; 
import Header from "../Components/Header";
import CartService from "../Services/CartService";

const headerLinks = [{ name: "Home", href: "/" }];

const ProductOrientation: React.FC = observer(() => {
  const [showBorder, setShowBorder] = useState<number | null>(null);
  const [cartItemCount, setCartItemCount] = useState(0);
  const navigate = useNavigate();

  const fetchCartCount = async () => {
    try {
      const { CartCount } = await CartService.GetCartCount();
      setCartItemCount(CartCount);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  useEffect(() => {
    fetchCartCount(); // Fetch cart count when the component mounts
  }, []);
  const handleRadioButton = (index: number, orientation: string) => {
    setShowBorder(index);
    productOrientationStore.setSelectedOrientation(index, orientation);
  };

  const showSection = () => {
    navigate(process.env.REACT_APP_PublicPath + "/productsize", { replace: false });
  };

  return (
    <><Header cartItemsCount={cartItemCount}  title="My Website" links={headerLinks} /><section className="ProductOrientations">
      <div className="mx-auto max-w-7xl mt-10 mb-40 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-normal text-center">Select a Product Orientation</h1>
        <div className="flex justify-center mt-8">
          {/* Vertical Orientation */}
          <div
            className={(showBorder === 1 ? "border-slate-sel" : "") +
              " mr-4 block max-w-sm p-4 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"}
          >
            <div className="flex flex-col items-center">
              <img src={Vertical} alt="Vertical" className="h-56 w-auto" />
              <h5 className="mb-1 text-base font-medium text-gray-900 dark:text-white pt-3">
                Vertical
              </h5>
              <span className="pt-0">
                <input
                  type="radio"
                  className="h-5 w-5"
                  name="productOrientation"
                  onClick={() => handleRadioButton(1, "Vertical")} />
              </span>
            </div>
          </div>

          {/* Horizontal Orientation */}
          <div
            className={(showBorder === 2 ? "border-slate-sel" : "") +
              " mr-4 block max-w-sm p-4 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"}
          >
            <div className="flex flex-col items-center">
              <img src={Horizontal} alt="Horizontal" className="h-56 w-auto" />
              <h5 className="mb-1 text-base font-medium text-gray-900 dark:text-white pt-3">
                Horizontal
              </h5>
              <span className="pt-0">
                <input
                  type="radio"
                  className="h-5 w-5"
                  name="productOrientation"
                  onClick={() => handleRadioButton(2, "Horizontal")} />
              </span>
            </div>
          </div>

          {/* Square Orientation */}
          <div
            className={(showBorder === 3 ? "border-slate-sel" : "") +
              " mr-4 block max-w-sm p-4 text-center border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"}
          >
            <div className="flex flex-col items-center">
              <img src={Square} alt="Square" className="h-56 w-auto" />
              <h5 className="mb-1 text-base font-medium text-gray-900 dark:text-white pt-3">
                Square
              </h5>
              <span className="pt-0">
                <input
                  type="radio"
                  className="h-5 w-5"
                  name="productOrientation"
                  onClick={() => handleRadioButton(3, "Square")} />
              </span>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        {showBorder !== null && (
          <div className="flex justify-center">
            <div className="mt-10 w-80">
              <button
                type="submit"
                className="w-full py-2 px-4 bg-green font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                onClick={showSection}
              >
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
    </section></>
  );
});

export default ProductOrientation;
